import Log from '../../logger/Log';
import Vue from 'vue';
const TAG = 'screen/store';
const store = {
    state: {
        screen: {
            size: undefined,
        },
        global: {},
    },
    mutations: {
        resize(state, payload) {
            Log.debug(TAG, 'resize', state, payload);
            state.screen.size = payload;
        },
        setGlobal(state, { key, val, }) {
            Log.debug(TAG, 'setGlobal', state, { key, val });
            Vue.set(state.global, key, val);
        },
    },
};
export default store;
